import { VisuallyHidden as VisuallyHidden$1 } from '@ariakit/react';
var VisuallyHidden = VisuallyHidden$1;
export { VisuallyHidden };